document.addEventListener("DOMContentLoaded", function () {

  const bottomBar = document.querySelector(".bundle-sticky-bar");
  if (!bottomBar) return;

  const tabs = document.querySelectorAll(".bundle-offer-item");
  const progressText = document.querySelector(".bundle-progress-text");
  const itemsWrapper = document.querySelector(".bundle-items-wrapper");
  const totalText = document.querySelector(".bundle-total");
  const unlockMessageMob = document.querySelector(".wrapper-mobile-unlock-message");
  const unlockMessagedesk = document.querySelector(".wrapper-desktop-unlock-message");
  const checkoutBtn = document.querySelector(".bundle-checkout-btn");

  let tierQty = parseInt(bottomBar.dataset.tierQty);
  let tierPrice = parseInt(bottomBar.dataset.tierPrice);

  let selectedProducts = [];

  /* =========================================
     GET MAX LIMIT (LAST TAB QTY)
  ========================================= */

  let maxLimit = 0;
  tabs.forEach(tab => {
    const tabQty = parseInt(tab.dataset.productCount);
    if (tabQty > maxLimit) maxLimit = tabQty;
  });

  /* =========================================
     INIT
  ========================================= */

  initializeTier(tierQty, tierPrice);

  /* =========================================
     TAB SWITCH
  ========================================= */

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      tierQty = parseInt(this.dataset.productCount);
      tierPrice = parseInt(this.dataset.offerValue);

     


      selectedProducts = [];
      initializeTier(tierQty, tierPrice);
    });
  });

  /* =========================================
     QTY + / - WITH REMAINING LIMIT
  ========================================= */

  document.addEventListener("click", function (e) {

    if (e.target.classList.contains("qty-plus")) {

      const wrapper = e.target.closest(".bundle-qty-selector");
      const input = wrapper.querySelector(".qty-input");

      const remaining = maxLimit - selectedProducts.length;
      let current = parseInt(input.value);

      if (current < remaining) {
        input.value = current + 1;
      }
    }

    if (e.target.classList.contains("qty-minus")) {

      const wrapper = e.target.closest(".bundle-qty-selector");
      const input = wrapper.querySelector(".qty-input");

      if (parseInt(input.value) > 1) {
        input.value--;
      }
    }

  });

  /* =========================================
     PREVENT MANUAL OVER-TYPING
  ========================================= */

  document.addEventListener("input", function (e) {

    if (!e.target.classList.contains("qty-input")) return;

    const remaining = maxLimit - selectedProducts.length;
    let value = parseInt(e.target.value);

    if (isNaN(value) || value < 1) value = 1;
    if (value > remaining) value = remaining;

    e.target.value = value;
  });

  /* =========================================
     ADD PRODUCT
  ========================================= */

  document.addEventListener("click", function (e) {

    if (!e.target.classList.contains("bundle-add-btn")) return;

    const remaining = maxLimit - selectedProducts.length;

    if (remaining <= 0) {
      alert("Maximum bundle quantity reached.");
      return;
    }

    const card = e.target.closest(".bundle-product-card");
    if (!card) return;

    const variantId = card.dataset.variantId;
    const image = card.querySelector("img")?.src;
    const price = parseFloat(card.dataset.price || 0);
    let quantity = parseInt(card.querySelector(".qty-input")?.value || 1);

    if (quantity > remaining) quantity = remaining;

    for (let i = 0; i < quantity; i++) {
      selectedProducts.push({
        id: variantId,
        image,
        price
      });
    }

    autoUpgradeTier();
    updateSlots();

    // clevertap event add to cart bundle item added
    
    pushCTEvent("bundle_item_added", {
      variant_id: variantId,
      price: price,
      quantity_added: quantity,
      total_selected_after: selectedProducts.length,
      active_tier: tierQty,
      offerValue: tierPrice,
      offerText: `Add ${tierQty} products to get ${tierQty} @ Rs.${tierPrice}`
    });

   
  });

  /* =========================================
     AUTO TIER UPGRADE
  ========================================= */

  function autoUpgradeTier() {

    const totalQty = selectedProducts.length;
    let bestTier = null;

    tabs.forEach(tab => {
      const tabQty = parseInt(tab.dataset.productCount);
      if (totalQty >= tabQty) bestTier = tab;
    });

    if (bestTier) {
      tabs.forEach(t => t.classList.remove("active"));
      bestTier.classList.add("active");

      tierQty = parseInt(bestTier.dataset.productCount);
      tierPrice = parseInt(bestTier.dataset.offerValue);

      initializeTier(tierQty, tierPrice, true);
    }
  }

  /* =========================================
     INIT TIER
  ========================================= */

  function initializeTier(qty, price, preserve = false) {

    progressText.innerText =
      `Add ${qty} products to get ${qty} @ Rs.${price}`;

    generateSlots(qty);

    if (!preserve) selectedProducts = [];

    updateTotal();
    toggleAddButtons();
    updateQtyLimits();
  }

  /* =========================================
     GENERATE SLOTS
  ========================================= */

  function generateSlots(qty) {

    itemsWrapper.innerHTML = "";

    for (let i = 1; i <= qty; i++) {
      const slot = document.createElement("div");
      slot.classList.add("bundle-item-slot", "empty");
      slot.innerText = "Item " + i;
      itemsWrapper.appendChild(slot);
    }
  }

  /* =========================================
     UPDATE SLOT UI
  ========================================= */

  function updateSlots() {

    const slots = document.querySelectorAll(".bundle-item-slot");

    slots.forEach((slot, index) => {

      if (selectedProducts[index]) {

        const p = selectedProducts[index];

        slot.classList.remove("empty");
        slot.classList.add("filled");

        slot.innerHTML = `
          <img src="${p.image}">
          <div class="bundle-remove" data-index="${index}">×</div>
        `;

      } else {

        slot.classList.remove("filled");
        slot.classList.add("empty");
        slot.innerHTML = "Item " + (index + 1);
      }
    });

    updateTotal();
    toggleAddButtons();
    updateQtyLimits();
  }

  /* =========================================
     REMOVE PRODUCT
  ========================================= */

  document.addEventListener("click", function (e) {

    if (!e.target.classList.contains("bundle-remove")) return;

    const index = parseInt(e.target.dataset.index);
    selectedProducts.splice(index, 1);

    autoUpgradeTier();
    updateSlots();

    pushCTEvent("bundle_item_removed", {
      removed_index: index,
      remaining_count: selectedProducts.length,
      active_tier: tierQty
    });

     console.log("bundle_item_removed",{
      removed_index: index,
      remaining_count: selectedProducts.length,
      active_tier: tierQty
    })


  });

  /* =========================================
     UPDATE QTY LIMITS
  ========================================= */

  function updateQtyLimits() {

    const remaining = maxLimit - selectedProducts.length;

    const qtyInputs = document.querySelectorAll(".qty-input");

    qtyInputs.forEach(input => {

      input.setAttribute("max", remaining);

      if (remaining <= 0) {
        input.value = 1;
        input.disabled = true;
      } else {
        input.disabled = false;

        if (parseInt(input.value) > remaining) {
          input.value = remaining;
        }
      }
    });
  }

  /* =========================================
     DYNAMIC PRICING LOGIC
  ========================================= */

  function updateTotal() {

    const totalQty = selectedProducts.length;

    const totalActualPrice = selectedProducts.reduce((sum, p) => {
      return sum + p.price;
    }, 0);

    if (totalQty >= tierQty) {

      const fullBundles = Math.floor(totalQty / tierQty);
      const bundleTotal = fullBundles * tierPrice;
      let savings = totalActualPrice - bundleTotal;
      if (savings < 0) savings = 0;

      totalText.innerHTML = `
         <div class="bundle-total-inner">Total: ₹${bundleTotal}</div>
        <div class="bundle-mrp">MRP ₹${totalActualPrice}</div>
        ${savings > 0 ? `<div class="bundle-savings">You Save ₹${savings}</div>` : ""}
      `;
     unlockMessageMob.innerHTML = ` `;
     unlockMessagedesk.innerHTML = ` `;
     checkoutBtn.disabled = false;

    } else {

      totalText.innerHTML = `<div>Total: ₹${totalActualPrice}</div>`;
      checkoutBtn.disabled = true;

      unlockMessageMob.innerHTML = `
        <div class="unlock-message"> ${tierQty - selectedProducts.length} Item Away from Unlocking</div>
      `;
      unlockMessagedesk.innerHTML = `
        <div class="unlock-message"> ${tierQty - selectedProducts.length} Item Away from Unlocking</div>
      `;
    }
  }

  /* =========================================
     DISABLE ADD BUTTONS AT MAX
  ========================================= */

  function toggleAddButtons() {

    const buttons = document.querySelectorAll(".bundle-add-btn");

    if (selectedProducts.length >= maxLimit) {
      buttons.forEach(btn => btn.disabled = true);
    } else {
      buttons.forEach(btn => btn.disabled = false);
    }
  }

  /* =========================================
     CART DRAWER ADD TO CART
  ========================================= */

  checkoutBtn.addEventListener("click", async function () {

    // bundle_checkout_clicked  Final check before adding to cart
      pushCTEvent("bundle_checkout_clicked", {
        total_items: selectedProducts.length,
        tier_qty: tierQty,
        page: window.location.pathname,
        offerText: `Add ${tierQty} products to get ${tierQty} @ Rs.${tierPrice}`,
        offerValue: tierPrice
    });

  

    if (selectedProducts.length < tierQty) return;

    const variantIds = selectedProducts.map(p => p.id);

    const cart =
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification");

    checkoutBtn.disabled = true;
    checkoutBtn.dataset.originalText = checkoutBtn.innerHTML;
    checkoutBtn.innerHTML = "Adding…";

    try {

      const items = variantIds.map(id => ({
        id,
        quantity: 1
      }));

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          items,
          ...(cart && {
            sections: cart.getSectionsToRender().map(s => s.id),
            sections_url: window.location.pathname
          })
        })
      });

      const data = await response.json();

      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(data);
        cart.classList.remove("is-empty");

        selectedProducts = [];
        initializeTier(tierQty, tierPrice);
      } else {
        window.location.href = "/cart";
      }

    } catch (err) {
      console.error("Bundle cart error:", err);
      alert("Something went wrong. Try again.");
    }

    checkoutBtn.disabled = false;
    checkoutBtn.innerHTML = checkoutBtn.dataset.originalText;

    // clevertap event add to cart bundle checkout clicked
    pushCTEvent("bundle_checkout_success", {
      total_items: selectedProducts.length,
      tier_qty: tierQty,
      page: window.location.pathname,
      offerText: `Add ${tierQty} products to get ${tierQty} @ Rs.${tierPrice}`,
      offerValue: tierPrice,
      cart_type: "drawer"
    });

    console.log("bundle_checkout_success", {
      total_items: selectedProducts.length,
      tier_qty: tierQty,
      page: window.location.pathname,
      offerText: `Add ${tierQty} products to get ${tierQty} @ Rs.${tierPrice}`,
      offerValue: tierPrice,
      cart_type: "drawer"   
      });

  });

  /* =========================================
     INFINITE SCROLL SAFE
  ========================================= */

  const productGrid = document.querySelector("#product-grid");

  if (productGrid) {
    const observer = new MutationObserver(() => {
      toggleAddButtons();
      updateQtyLimits();
    });

    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }


/* =========================================
   CLEVERTAP SAFE WRAPPER
========================================= */

function pushCTEvent(eventName, props = {}) {

  if (window.clevertap && clevertap.event) {
    clevertap.event.push(eventName, props);
  }

}


});
